import { render } from "./MenuPage.vue?vue&type=template&id=f183b6f0&scoped=true&ts=true"
import script from "./MenuPage.vue?vue&type=script&lang=ts"
export * from "./MenuPage.vue?vue&type=script&lang=ts"

import "./MenuPage.vue?vue&type=style&index=0&id=f183b6f0&lang=scss&scoped=true"

import exportComponent from "/root/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f183b6f0"]])

export default __exports__